























































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class App extends Vue {
  [x: string]: any

  public get year() {
    const date = new Date()
    return date.getFullYear()
  }

  protected loading: boolean = true
  protected showError: boolean = false
  protected errorMessage: string = 'Unknown Error'
  protected valid: boolean = true
  protected validationErrors: Array<string> = []
  private clipped: boolean = true
  private drawer: boolean = true
  private miniVariant: boolean = false
  private right: boolean = true
  private title: string = 'CTC Products Portal'

  private openitems = [{ id: 1, title: 'Home', icon: 'home', link: '/' }]

  private secureditems = [
    { id: 1, title: 'Products', icon: 'donut_small', link: '/products' },
    { id: 2, title: 'Tools', icon: 'donut_large', link: '/tools' },
    // { id: 3, title: 'Site Messages', icon: 'donut_large', link: '/sitemessages' },
  ]

  private nonEmpty: Array<object> = [(v) => !!v.trim() || 'This is required.']
  private nonEmptyArray: Array<object> = [(v) => (!!v && v.length > 0) || 'This is required.']
  private nonNegativeNumber: Array<object> = [
    (v) => !!v || 'This is required.',
    (v) => !isNaN(Number(v)) || 'This has to be a number.',
    (v) => Number(v) >= 0 || 'This has to be non-negative.',
  ]
  private nonNegativeInteger: Array<object> = [...this.nonNegativeNumber, (v) => Number.isInteger(Number(v)) || 'This has to be an integer.']

  protected resetValidation() {
    this.validationErrors = []
    const form: any = this.$refs.form
    if (form) {
      form.resetValidation()
    }
  }

  private logout() {
    this.$auth.logout({
      returnTo: window.location.origin,
    })
  }

  private login() {
    this.$auth.loginWithRedirect()
  }
}
